// frontend/src/apiWithKnowledge.js
import api from "./apiWithAccessToken";

//DATA (Schema Glossary)
   
//Get tables selected in Database tab(Read-only context for Knowledge)
 
export const getSelectedTablesForKnowledge = (configId) =>
  api.get(`/show/selected-tables/${configId}`);

// Get table schema with existing glossary data

export const getTableSchemaForKnowledge = (payload) =>
  api.post("/show/table-columns", payload);

// Save table description + column glossary Triggers RAG ingestion
 
export const saveTableKnowledge = (payload) =>
  api.post("/show/save-full-metadata", payload);

//Auto-generate column examples from source DB
export const generateColumnExamples = (payload) =>
  api.post("/show/generate-examples", payload);


/* =====================================================
   GENERAL INSTRUCTION (1 per source DB)
   ===================================================== */

export const getGeneralInstructionBySource = (sourceDbId) =>
  api.get(`/general-instruction/source/${sourceDbId}`);

export const createGeneralInstruction = (payload) =>
  api.post("/general-instruction", payload);

export const updateGeneralInstruction = (id, payload) =>
  api.put(`/general-instruction/${id}`, payload);

export const deleteGeneralInstruction = (id) =>
  api.delete(`/general-instruction/${id}`);


/* =====================================================
   JOIN INSTRUCTIONS (Relationships)
   ===================================================== */

// Metadata
export const getJoinTables = (configId) =>
  api.get(`/join-instruction/metadata/tables/${configId}`);

export const getJoinColumns = (sourceDbId, tableName) =>
  api.get(`/join-instruction/metadata/columns/${sourceDbId}/${encodeURIComponent(tableName)}`);

// CRUD
export const createJoinInstruction = (payload) =>
  api.post("/join-instruction", payload);

export const getJoinInstructionsBySource = (sourceDbId) =>
  api.get(`/join-instruction/source/${sourceDbId}`);

export const updateJoinInstruction = (id, payload) =>
  api.put(`/join-instruction/${id}`, payload);

export const deleteJoinInstruction = (id) =>
  api.delete(`/join-instruction/${id}`);


/* =====================================================
   SQL EXPRESSIONS (Measures / Dimensions / Filters)
   ===================================================== */

export const createSqlExpression = (payload) =>
  api.post("/sql-expression", payload);

export const getSqlExpressionsBySource = (sourceDbId) =>
  api.get(`/sql-expression/source/${sourceDbId}`);

export const updateSqlExpression = (id, payload) =>
  api.put(`/sql-expression/${id}`, payload);

export const deleteSqlExpression = (id) =>
  api.delete(`/sql-expression/${id}`);

export const getSqlValidationContext = (sourceDbId) =>
  api.get(`/sql-validation/context/${sourceDbId}`);

export const validateKnowledgeSql = (payload) =>
  api.post("/sql-validation/validate", payload);


/* =====================================================
   QUERY INSTRUCTIONS (NL → SQL examples)
   ===================================================== */

export const createQueryInstruction = (payload) =>
  api.post("/query-instruction", payload);

export const getQueryInstructionsBySource = (sourceDbId) =>
  api.get(`/query-instruction/source/${sourceDbId}`);

export const getQueryInstructionById = (id) =>
  api.get(`/query-instruction/${id}`);

export const updateQueryInstruction = (id, payload) =>
  api.put(`/query-instruction/${id}`, payload);

export const deleteQueryInstruction = (id) =>
  api.delete(`/query-instruction/${id}`);
